/* hb-dots.js - Havin Bag : indicateur du carrousel de la fiche produit.
   Masque les fleches et le compteur "1 / 5", et pose a la place une rangee de petits carres
   en bas a gauche de la photo (18 px du bord gauche et du bord bas). L'etat suit le compteur
   d'origine, masque mais conserve, donc l'indicateur reste juste au swipe comme au changement
   de variante.
   05/10 : le halo blanc autour des carres a ete retire a la demande de Bastos (taches floues sur
   les photos sombres). Les carres restent sobres.
   05/10 : la derniere photo accrochait au defilement. Le theme ajoute un scroll-padding-left de
   15 px et un ::after de 15 px a la liste d'images, ce qui rend la course de defilement plus longue
   que le dernier point d'ancrage : le navigateur hesite entre les deux et la diapositive ne se cale
   jamais franchement. Les deux sont neutralises ci-dessous.
   05/10 : lisere greige au-dessus et au-dessous de chaque photo. Le fond greige avait ete pose sur
   la liste entiere pour masquer la gouttiere blanche pendant le swipe, mais chaque diapositive a
   5 px de padding vertical, qui se retrouvaient peints en greige et formaient un lisere contre le
   blanc de la page. Le fond est retire et la gouttiere passe a zero : les photos se touchent
   pendant le swipe, plus de bande blanche a masquer, et plus de lisere.
   Genere le 2026-10-03. Pour desactiver : retirer la ligne "hb-dots.js" dans layout/theme.liquid. */
(function(){
try{
var W='.product__media-wrapper ';
var CSS=W+'.slider-buttons{display:none!important}'
+W+'slider-component.slider-mobile-gutter{position:relative!important}'
+'@media screen and (max-width:749px){'
+W+'.product__media-list{column-gap:0!important;scroll-padding-left:0!important}'
+W+'.product__media-list::after{width:0!important;display:none!important}'
+'}'
+'.hb-dots{position:absolute;left:18px;bottom:18px;z-index:3;display:flex;align-items:center;gap:5px;pointer-events:none}'
+'.hb-dots i{display:block;width:6px;height:6px;background:rgba(33,31,27,.25);transition:background .15s}'
+'.hb-dots i.on{background:#211F1B}';
function init(){
 var sc=document.querySelector(W+'slider-component.slider-mobile-gutter');
 if(!sc||sc.__hbDots)return;
 var c=sc.querySelector('.slider-counter');if(!c)return;
 var tot=c.querySelector('.slider-counter--total'),cur=c.querySelector('.slider-counter--current');
 if(!tot||!cur)return;
 sc.__hbDots=1;
 if(!document.getElementById('hb-dots-css')){var s=document.createElement('style');s.id='hb-dots-css';s.textContent=CSS;document.head.appendChild(s);}
 var row=document.createElement('div');row.className='hb-dots';row.setAttribute('aria-hidden','true');sc.appendChild(row);
 function sync(){
  var n=parseInt(tot.textContent,10)||0,i=parseInt(cur.textContent,10)||1,j;
  if(row.children.length!==n){row.innerHTML='';for(j=0;j<n;j++)row.appendChild(document.createElement('i'));}
  for(j=0;j<row.children.length;j++)row.children[j].classList.toggle('on',j===i-1);
 }
 sync();
 new MutationObserver(sync).observe(c,{childList:true,subtree:true,characterData:true});
}
var pend=0;
function schedule(){if(pend)return;pend=1;requestAnimationFrame(function(){pend=0;init();});}
init();
document.addEventListener('DOMContentLoaded',init);
new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
}catch(e){}
})();

/* --- Bandeau d'achat colle en bas de la fiche (ajout du 05/10) ---------------
   Le bandeau .hb-sticky existe deja dans le theme, mais il portait la classe
   "is-on" en permanence : il s'affichait des le haut de la fiche, ce qui
   doublait le bouton principal et mangeait 69 px de hauteur utile sans rien
   apporter. Il est desormais lie au bouton d'ajout au panier : il remonte
   quand ce bouton sort de l'ecran, il redescend quand il revient.
   Second point : en mode apercu, la barre Shopify (environ 68 px) recouvre le
   bas de la fenetre et masquait entierement le bandeau, impossible a passer
   devant par z-index. Sa hauteur est donc mesuree au chargement et le bandeau
   est pose juste au-dessus. Sur le site publie cette barre n'existe pas, la
   mesure renvoie zero, et le bandeau reste colle au bas de l'ecran. */
(function(){
try{
 function hauteurBarreApercu(){
  try{
   var x=Math.round(window.innerWidth/2), y=window.innerHeight-2, h=0;
   while(y>window.innerHeight-200){
    var e=document.elementFromPoint(x,y);
    if(!e||e.tagName!=='IFRAME'){h=window.innerHeight-y-1;break;}
    y--;
   }
   return h>4?h:0;
  }catch(err){return 0;}
 }
 function cale(){
  var s=document.querySelector('.hb-sticky');
  if(!s)return;
  s.style.bottom=hauteurBarreApercu()+'px';
 }
 function lier(){
  var s=document.querySelector('.hb-sticky');
  var b=document.querySelector('button[name=add]');
  if(!s||!b||s.__hbLie)return;
  s.__hbLie=1;
  cale();
  s.classList.remove('is-on');
  new IntersectionObserver(function(ev){
   ev.forEach(function(x){ s.classList.toggle('is-on',!x.isIntersecting); });
  },{threshold:0}).observe(b);
 }
 lier();
 document.addEventListener('DOMContentLoaded',lier);
 window.addEventListener('load',function(){lier();cale();});
 window.addEventListener('resize',cale);
 var p=0;
 new MutationObserver(function(){
  if(p)return;p=1;
  requestAnimationFrame(function(){p=0;lier();});
 }).observe(document.documentElement,{childList:true,subtree:true});
}catch(e){}
})();